import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { apiFetch } from "../config";

function Controle() {
  const { id } = useParams();
  const [cours, setCours] = useState(null);
  const [etudiants, setEtudiants] = useState(null);
  const [erreur, setErreur] = useState("");

  const charger = useCallback(() => {
    apiFetch(`/controle/${id}`)
      .then(async (r) => {
        if (r.status === 403) throw new Error("Tu n'es pas l'enseignant de ce cours.");
        if (!r.ok) throw new Error("Erreur de chargement.");
        return r.json();
      })
      .then((liste) => {
        setEtudiants(liste);
        setErreur("");
      })
      .catch((e) => setErreur(e.message));
  }, [id]);

  useEffect(() => {
    apiFetch(`/cours/${id}`)
      .then((r) => r.json())
      .then(setCours)
      .catch(() => setCours(null));
    charger();
    // Rafraîchit pour voir les étudiants qui viennent de scanner le QR
    const timer = setInterval(charger, 10000);
    return () => clearInterval(timer);
  }, [id, charger]);

  const basculer = async (etu) => {
    const presence = !etu.presence;
    setEtudiants((liste) =>
      liste.map((e) => (e.num_etudiant === etu.num_etudiant ? { ...e, presence } : e))
    );
    try {
      const r = await apiFetch(`/controle/${id}/${encodeURIComponent(etu.num_etudiant)}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ presence }),
      });
      if (!r.ok) throw new Error();
    } catch {
      setErreur("Modification impossible.");
      charger();
    }
  };

  const nbPresents = etudiants ? etudiants.filter((e) => e.presence).length : 0;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Contrôle des présences</h2>

        {cours && (
          <div style={styles.courseInfo}>
            <p style={styles.courseTitle}>{cours.intitule}</p>
            <p style={styles.courseMeta}>
              {new Date(cours.date).toLocaleDateString("fr-FR")} &bull;{" "}
              {cours.heure_debut?.slice(0, 5)} – {cours.heure_fin?.slice(0, 5)}
            </p>
          </div>
        )}

        {erreur && <p style={styles.error}>{erreur}</p>}

        {etudiants && (
          <>
            <p style={styles.courseMeta}>
              {nbPresents} présent(s) sur {etudiants.length}
            </p>
            <ul style={styles.list}>
              {etudiants.map((e) => (
                <li key={e.num_etudiant} style={styles.item}>
                  <label style={styles.label}>
                    <input
                      type="checkbox"
                      checked={e.presence}
                      onChange={() => basculer(e)}
                      style={styles.checkbox}
                    />
                    {e.nom} {e.prenom}
                    <span style={styles.num}>{e.num_etudiant}</span>
                  </label>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    background: "#f0f4f8",
    padding: "20px",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "24px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "520px",
    alignSelf: "flex-start",
  },
  title: { textAlign: "center", marginBottom: "16px", fontSize: "22px", color: "#1a1a2e" },
  courseInfo: { background: "#f7f9fc", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px" },
  courseTitle: { fontWeight: "bold", fontSize: "16px", margin: "0 0 4px 0", color: "#1a1a2e" },
  courseMeta: { fontSize: "13px", color: "#666", margin: "2px 0" },
  list: { listStyle: "none", padding: 0, margin: "12px 0 0 0" },
  item: { borderBottom: "1px solid #eee" },
  label: { display: "flex", alignItems: "center", gap: "12px", padding: "12px 4px", cursor: "pointer", fontSize: "16px" },
  checkbox: { width: "20px", height: "20px" },
  num: { marginLeft: "auto", fontSize: "13px", color: "#666" },
  error: { textAlign: "center", color: "#dc2626", fontSize: "14px", marginTop: "8px" },
};

export default Controle;
